"use strict";

( function( namespace ) {
	var parselyLoaded = false;
	var hash = 0;
	var site_id = "";
	var domain_id = "";

	var get = function( object, path, defaultValue ) {
		path = path.split( "." );

		var index = 0;
		var length = path.length;

		while ( object != null && index < length ) {
			object = object[ path[ index++ ] ];
		}

		var result = ( index && index == length ) ? object : undefined;

		return result === undefined ? defaultValue : result;
	};

	namespace._fireVideoEvent = function( label, type, data, event_value ) {
		data = data || {};

		var eventData = {
			eID: data.embed_id,
			vID: data.video_id,
			hash: hash,
			refUrl: data.referral,
			url: data.fullUrl,
			autoPlay: data.autoplay,
			disableAds: data.disable_ads,
			pMute: data.mute,
			pPosition: data.embed_position,
			pType: data.playerType,
			pWidth: data.playerWidth,
			pHeight: data.playerHeight,
			pVersion: data.version,
			clientTimestamp: ( data.diagTimestamp ) ? data.diagTimestamp : Date.now(),
		};

		var adData = {
			tagUrl: data.ad_tag_url,
			adType: data.client,
			creativeType: data.creativetype,
			adPosition: data.adposition,
		};

		if ( label === "HRST_Ad" ) {
			for ( var att in adData ) {
				eventData[ att ] = adData[ att ];
			}
		}

		if ( event_value !== undefined ) {
			eventData.event_value = event_value;
		}

		_hearstPageView( label, type, eventData );

	};

	namespace._fireVideoTrackingPlayEvent = function( player, playerData ) {
		if ( typeof ( window.PARSELY.video ) === "undefined" ) {
			return;
		}

		videojs.log( "parsely _fireVideoTrackingPlayEvent" );

		var eventData = getParselyVideoMetadata( player, playerData );
		window.PARSELY.video.trackPlay( playerData.video_id, eventData, window.location.href );
	};

	namespace._fireVideoTrackingPauseEvent = function( player, playerData ) {
		if ( typeof ( window.PARSELY.video ) === "undefined" ) {
			return;
		}

		videojs.log( "parsely _fireVideoTrackingPauseEvent" );

		var eventData = getParselyVideoMetadata( player, playerData );
		window.PARSELY.video.trackPause( playerData.video_id, eventData, window.location.href );
	};

	var getParselyVideoMetadata = function( player, playerData ) {
		var videoDuration = player.duration();
		if ( isNaN( videoDuration ) ) {
			videoDuration = 0;
		}

		var date = new Date( get( playerData, "created_at", Date.now() ) );

		var eventData = {
			duration: Math.floor( videoDuration ) * 1000,
			image_url: playerData.poster,
			pub_date_tmsp: date.getTime(),
			title: playerData.video_title,
			video_platform: "videojs",
		};

		return eventData;
	};

	var _firePlayerDiagEvent = function( type, timestamp, event_value ) {
		var data = {
			diagTimestamp: ( timestamp ) ? timestamp : Date.now(),
		};

		if ( event_value !== undefined ) {
			namespace._fireVideoEvent( "HRST_Diag", type, data, event_value );
		} else {
			namespace._fireVideoEvent( "HRST_Diag", type, data );
		}
	};

	var _hearstPageView = function( event_label, event_type, vars ) {
		var url = document.referrer;
		var urlref = "";
		var config = {
			url: ( ( vars.fullUrl ) ? vars.fullUrl : url ),
			urlref: ( ( vars.referral ) ? vars.referral : urlref ),
			data: vars,
			action: "Hearst_Video",
		};

		config.data.cId = site_id;
		config.data.cdid = domain_id;
		config.data.icxid = window.PARSELY.Cookies.get( "icxid" ) || "";
		config.data.event_label = event_label;
		config.data.event_type = event_type;

		window.PARSELY.beacon.trackPageView( config );
	};

	namespace.loadParsely = function( site_data ) {
		if ( parselyLoaded ) {
			return;
		}

		parselyLoaded = true;

		hash = site_data.hash;

		site_id = site_data.site_id;

		domain_id = site_data.domain_id;

		var timestamp = Date.now();

		_firePlayerDiagEvent( "init", timestamp );
	};
} )( window.hearstLumierePlayer = window.hearstLumierePlayer || /* istanbul ignore next */ {} );



//////////////////
// WEBPACK FOOTER
// ./src/parsely.js
// module id = 190
// module chunks = 0